import '../__generated__/styles/checkbox.css';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import { useTheme } from '@paypalcorp/pp-react-theme';
import clsx from 'clsx';
import { V2CheckmarkIcon, CheckAltIcon, V2CriticalIcon, CriticalAltIcon } from '@paypalcorp/pp-react-icons';

var styles = {"ppvx_checkbox-group":"ppvx_checkbox-group___3-6-11-beta-0","ppvx_checkbox":"ppvx_checkbox___3-6-11-beta-0","ppvx_checkbox__label":"ppvx_checkbox__label___3-6-11-beta-0","ppvx_checkbox__check-icon-container":"ppvx_checkbox__check-icon-container___3-6-11-beta-0","ppvx_checkbox__check-icon":"ppvx_checkbox__check-icon___3-6-11-beta-0","ppvx_icon":"ppvx_icon___3-6-11-beta-0","ppvx_checkbox__label-icon":"ppvx_checkbox__label-icon___3-6-11-beta-0","ppvx_checkbox__input":"ppvx_checkbox__input___3-6-11-beta-0","ppvx_checkbox__label--with-svg-icon":"ppvx_checkbox__label--with-svg-icon___3-6-11-beta-0","ppvx_field--error":"ppvx_field--error___3-6-11-beta-0","ppvx_checkbox-group__label":"ppvx_checkbox-group__label___3-6-11-beta-0","ppvx_checkbox__helper-text":"ppvx_checkbox__helper-text___3-6-11-beta-0","ppvx_checkbox-group__helper-text":"ppvx_checkbox-group__helper-text___3-6-11-beta-0","ppvx_checkbox-group__error-text":"ppvx_checkbox-group__error-text___3-6-11-beta-0","ppvx_checkbox__error-text":"ppvx_checkbox__error-text___3-6-11-beta-0","ppvx_checkbox__error-icon":"ppvx_checkbox__error-icon___3-6-11-beta-0","ppvx_checkbox-group__error-text--with-svg-icon":"ppvx_checkbox-group__error-text--with-svg-icon___3-6-11-beta-0","ppvx_checkbox__error-text--with-svg-icon":"ppvx_checkbox__error-text--with-svg-icon___3-6-11-beta-0","ppvx--v2":"ppvx--v2___3-6-11-beta-0","ppvx--v1":"ppvx--v1___3-6-11-beta-0"};

/* istanbul ignore next */
var uniqueId = function (id) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';
  return id === undefined ? "".concat(prefix).concat(Math.random().toFixed(8).toString().replace('0.', '')) : id;
};

var renderLabel = function (text, id, labelIcon, error, helperText, isThemeV2) {
  var labelIconElm = labelIcon && /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_checkbox__label-icon']
  }, labelIcon);
  var checkboxCheckIcon = isThemeV2 ? /*#__PURE__*/React.createElement(V2CheckmarkIcon, {
    className: styles['ppvx_checkbox__check-icon'],
    size: "sm"
  }) : /*#__PURE__*/React.createElement(CheckAltIcon, {
    className: styles['ppvx_checkbox__check-icon'],
    size: "xs"
  });
  var helperTextElm = !error && helperText && /*#__PURE__*/React.createElement("p", {
    className: styles['ppvx_checkbox__helper-text']
  }, helperText);
  var cls = clsx(styles.ppvx_checkbox__label, styles['ppvx_checkbox__label--with-svg-icon']);
  return /*#__PURE__*/React.createElement("label", {
    className: cls,
    htmlFor: id
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_checkbox__check-icon-container']
  }, checkboxCheckIcon), text, labelIconElm, helperTextElm);
};

var Checkbox = forwardRef(function (_ref, ref) {
  var _clsx;

  var id = _ref.id,
      label = _ref.label,
      labelIcon = _ref.labelIcon,
      helperText = _ref.helperText,
      errorText = _ref.errorText,
      error = _ref.error,
      name = _ref.name,
      dir = _ref.dir,
      className = _ref.className,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["id", "label", "labelIcon", "helperText", "errorText", "error", "name", "dir", "className", "theme"]);

  var _theme = useTheme('Checkbox', theme);

  var isThemeV2 = _theme && _theme === 'v2';
  var checkboxErrorIcon = isThemeV2 ? /*#__PURE__*/React.createElement(V2CriticalIcon, {
    className: styles['ppvx_checkbox__error-icon'],
    size: "sm"
  }) : /*#__PURE__*/React.createElement(CriticalAltIcon, {
    className: styles['ppvx_checkbox__error-icon'],
    size: "xs"
  });
  var checkboxId = "".concat(uniqueId(id, 'Checkbox_'));
  var errorClasses = clsx(styles['ppvx_checkbox__error-text'], styles['ppvx_checkbox__error-text--with-svg-icon']);
  var message = error && errorText && /*#__PURE__*/React.createElement("p", {
    className: errorClasses
  }, checkboxErrorIcon, errorText);
  var classes = clsx(styles.ppvx_checkbox, (_clsx = {}, _defineProperty(_clsx, styles['ppvx--v2'], isThemeV2), _defineProperty(_clsx, styles['ppvx_field--error'], error), _clsx), className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    dir: dir
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: styles.ppvx_checkbox__input,
    type: "checkbox",
    id: checkboxId,
    name: name,
    ref: ref
  }, rest)), renderLabel(label, checkboxId, labelIcon, error, helperText, isThemeV2), message);
});

var CheckboxGroup = function (_ref) {
  var _clsx, _clsx2;

  var label = _ref.label,
      labelIcon = _ref.labelIcon,
      helperText = _ref.helperText,
      errorText = _ref.errorText,
      error = _ref.error,
      className = _ref.className,
      children = _ref.children,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["label", "labelIcon", "helperText", "errorText", "error", "className", "children", "theme"]);

  var _theme = useTheme('RadioButton', theme);

  var isThemeV2 = _theme && _theme === 'v2';
  var checkboxErrorIcon = isThemeV2 ? /*#__PURE__*/React.createElement(V2CriticalIcon, {
    className: styles['ppvx_checkbox__error-icon'],
    size: "sm"
  }) : /*#__PURE__*/React.createElement(CriticalAltIcon, {
    className: styles['ppvx_checkbox__error-icon'],
    size: "xs"
  });
  var message = (errorText || helperText) && /*#__PURE__*/React.createElement("p", {
    className: clsx((_clsx = {}, _defineProperty(_clsx, styles['ppvx_checkbox-group__helper-text'], !error), _defineProperty(_clsx, styles['ppvx_checkbox-group__error-text'], error), _defineProperty(_clsx, styles['ppvx_checkbox-group__error-text--with-svg-icon'], error), _clsx))
  }, error && checkboxErrorIcon, error ? errorText : helperText);
  var labelIconElm = labelIcon && /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_checkbox__label-icon']
  }, labelIcon);
  return /*#__PURE__*/React.createElement("fieldset", _extends({
    className: clsx(styles['ppvx_checkbox-group'], (_clsx2 = {}, _defineProperty(_clsx2, styles['ppvx--v2'], isThemeV2), _defineProperty(_clsx2, styles['ppvx_field--error'], error), _clsx2), className)
  }, rest), /*#__PURE__*/React.createElement("legend", {
    className: styles['ppvx_checkbox-group__label']
  }, label, labelIconElm), children, message);
};

export { Checkbox, CheckboxGroup };
